import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "22",
  height: "22",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#a)" }, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "#000",
    d: "M14.723 19.83v-2.971h5.607l-3.241-4.821h2.447l-2.846-4.02h1.975l-4.273-6.99-4.27 6.99h1.976l-2.842 4.02h2.447l-3.245 4.82h5.607v2.972H4.814v-1.334a3.97 3.97 0 0 0 3.632-3.951 3.967 3.967 0 0 0-3.963-3.963 3.967 3.967 0 0 0-3.962 3.963c0 2.076 1.6 3.781 3.632 3.95v1.335H.52v.661h20.478v-.661zm-10.57-2a3.306 3.306 0 0 1-2.971-3.285 3.306 3.306 0 0 1 3.301-3.302 3.306 3.306 0 0 1 3.302 3.302c0 1.71-1.306 3.12-2.971 3.285v-1.967h-.661zm9.909-1.632H9.696l3.245-4.821h-2.41l2.841-4.02H11.3l3.092-5.063 3.092 5.063h-2.072l2.842 4.02h-2.41l3.245 4.82h-4.366v-2.313h-.661z"
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "a" }, [
    /*#__PURE__*/_createElementVNode("path", {
      fill: "#fff",
      d: "M.44.44h20.64v20.64H.44z"
    })
  ])
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }